import React from 'react';

import FavoriteIcon from '@swf/core/assets/casino/game-fav.svg';

export interface Props {
  onFavoriteClick(): void;
  favouriteIcon?: JSX.Element;
  classes: string;
}

const FavoriteGameIcon: React.FC<Props> = ({ onFavoriteClick, favouriteIcon, classes }) => (
  <div title="" className={classes} onClick={onFavoriteClick}>
    {favouriteIcon || <FavoriteIcon />}
  </div>
);
export default FavoriteGameIcon;
